import { find } from "lodash";

// eslint-disable-next-line import/prefer-default-export
export function parseFooterData(footerData) {
  const links = [];
  const myAccountLink = footerData.find(
    (el) => el.fields?.label?.toLowerCase() === "my account"
  );
  if (myAccountLink) {
    links.push({
      label: myAccountLink.fields.label,
      url: myAccountLink.fields.webRoute,
    });
  }
  const contactUsLink = footerData.find(
    (el) => el.fields?.label?.toLowerCase() === "contact us"
  );
  const careersLinks = footerData.find((el) =>
    el.fields?.name?.toLowerCase().includes("careers")
  );
  const giftCardLinks = footerData.find((el) =>
    el.fields?.name?.toLowerCase().includes("gift cards")
  );

  if (contactUsLink) {
    links.push({
      label: contactUsLink.fields.label,
      url: contactUsLink.fields.webRoute,
    });
  }

  const liveChatLink = find(
    contactUsLink?.fields?.links,
    (dt) => dt.fields.label.toLowerCase() === "live chat"
  );
  if (liveChatLink) {
    links.push({
      label: liveChatLink.fields.label,
      url: liveChatLink.fields.webRoute,
    });
  }

  const appDownloadLink = find(
    careersLinks?.fields?.links,
    (dt) => dt.fields.label.toLowerCase() === "lululemon apps"
  );
  if (appDownloadLink) {
    links.push({
      label: appDownloadLink.fields.label,
      url: appDownloadLink.fields.webRoute,
    });
  }

  const storeLocatorLink = find(
    giftCardLinks?.fields?.links,
    (dt) => dt.fields.label.toLowerCase() === "store locator"
  );

  if (storeLocatorLink) {
    links.push({
      label: storeLocatorLink.fields.label,
      url: storeLocatorLink.fields.webRoute,
    });
  }
  return links;
}
